__turbopack_context__.v({
  "className": "U3izCG_className",
});
